import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactApexChart from "react-apexcharts";

class PieCharts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      series: [],
      options: {
        colors: [
          "#556ee6",
          "#f1b44c",
          "#00CBE1",
          "#946BFA",
          "#FF6900",
          "#E6D4B6",
          "#FFB4B4",
          "#46E0DA",
          "#9491E0",
          "#FBBADC",
          "#E6E5B0",
          "#FFC8BA",
        ],
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          verticalAlign: "middle",
          floating: false,
          fontSize: "14px",
          // offsetX: 0,
          // offsetY: -10,
        },
        responsive: [
          {
            // breakpoint: 600,
            options: {
              chart: {
                height: 240,
              },
              legend: {
                show: false,
              },
            },
          },
        ],
      },
    };
  }

  getChartData = () => {
    const { data } = this.props;
    // eslint-disable-next-line no-undef
    const labels = data.results.map(i => i.media_source);
    const series = data.results.map(i => parseInt(i[`${this.props.name}`]));
    this.setState({
      series,
      options: {
        ...this.state.options,
        labels,
      },
    });
  };

  componentDidMount() {
    this.getChartData();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (JSON.stringify(this.props.data) !== JSON.stringify(prevProps.data)) {
      this.getChartData();
    }
  }

  render() {
    return (
      <React.Fragment>
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="pie"
          height="290"
          className="apex-charts"
        />
      </React.Fragment>
    );
  }
}

PieCharts.propTypes = {
  data: PropTypes.any,
  name: PropTypes.string,
};

export default PieCharts;
